import React, { ReactNode } from 'react'
import { FieldProps, getIn } from 'formik'
import { InputAdornment } from '@material-ui/core'
import Select from '../StyledSelect'
import { IOption } from '../../types/common'

interface ICustomSelectFieldProps {
  label: string
  placeholder?: string
  onChange?: (e: any) => void
  helperText?: string
  children: IOption[]
  disabled?: boolean
  validateImmediately?: boolean
  defaultValueAdornment?: ReactNode
}

// If you want rewrite some field props, try to pass there by params
export const CustomSelectField = ({
  field,
  form: { touched, errors },
  validateImmediately,
  placeholder,
  helperText,
  disabled,
  children,
  onChange,
  defaultValueAdornment,
  ...props
}: FieldProps<any> & ICustomSelectFieldProps) => {
  const isNotValid =
    (validateImmediately || getIn(touched, field.name)) &&
    !!getIn(errors, field.name)
  return (
    <Select
      {...field}
      {...props}
      id={field.name}
      placeholder={placeholder || ''}
      error={isNotValid}
      helperText={isNotValid ? getIn(errors, field.name) : helperText}
      endAdornment={
        defaultValueAdornment && (
          <InputAdornment position="end">{defaultValueAdornment}</InputAdornment>
        )
      }
      onChange={(e) => {
        if (onChange) {
          onChange(e)
        }
        field.onChange(e)
      }}
      disabled={disabled}
    >
      {children}
    </Select>
  )
}
